import { Component, OnInit, ViewChild } from '@angular/core';
import { GetExampleCommandResponse, SaveFormlyExampleCommandRequest } from '../../../../data/CommandServiceDtos.generated';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { FormGroup, NgForm } from '@angular/forms';
import { PageContainerService } from '../../../../services';
import { ControllerForViewBase } from '../../../framework/controller-for-view-base';
import { CanComponentDeactivate } from '../../../../services/can-deactivate-guard.service';
import { ActivatedRoute, Params } from '@angular/router';
@Component({
  standalone: false,
  selector: 'example-formly',
  templateUrl: './example-formly.component.html',
  styleUrls: ['./example-formly.component.scss']
})
export class ExampleFormlyComponent extends ControllerForViewBase implements OnInit, CanComponentDeactivate {
  form: FormGroup = new FormGroup({});
  model: SaveFormlyExampleCommandRequest = new SaveFormlyExampleCommandRequest();
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = SaveFormlyExampleCommandRequest.FormlyConfig;

  getActionText = () => this.model.Id > 0 ? 'Update' : 'Create';

  constructor(private activatedRoute: ActivatedRoute, pcs: PageContainerService) {
    super(pcs);
  }

  setActionLinks() {
    this.pcs.actionLinksPanelService.reset();
    this.pcs.actionLinksPanelService.addBackButton();
    this.pcs.actionLinksPanelService.addActionLinks([{
      text: 'Save ',
      fontAwesomeIcon: 'save',
      onClick: () => { this.submit() }
    }]);
    this.pcs.actionLinksPanelService.addActionLinks([{
      text: 'Save and Close',
      fontAwesomeIcon: 'save',
      onClick: () => { this.submit(true) }
    }]);
  }

  async ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.load(+params['id']);
    });
  }

  async load(id: number) {
    let getCommandResponse = await this.pcs.apiService.GetExample({ Id: id });
    this.mapResponseToModel(getCommandResponse);
    this.setActionLinks();
  }

  mapResponseToModel(getCommandResponse: GetExampleCommandResponse): void {
    this.model.Id = getCommandResponse.Id;
    this.model.DisplayText = getCommandResponse.DisplayText;
    this.model.Value = getCommandResponse.Value;
    this.model.ExampleLookupId = getCommandResponse.ExampleLookupId;
    this.fields.find(x => x.key == 'ExampleLookupId').templateOptions.options = getCommandResponse.ExampleLookups;
    this.form = new FormGroup({});
  }

  async submit(navigateaway: boolean = false): Promise<void> {
    let response = await this.pcs.apiService.SaveExample(this.model, undefined, true);
    this.form.markAsPristine();
    this.updateUrlForNewEntity(['/example-formly', response.Id]);
    if (navigateaway) {
      window.history.back();
    } else {
      this.load(response.Id);
    }
  }

  canDeactivate(): Promise<boolean> {
    var promise = Promise.resolve(true);
    if (this.form.dirty)
      return this.pcs.showUnsavedChangesDialog();
    return promise;
  }
}
